export default __webpack_public_path__ + "static/media/avatar_1.727dfaa9.svg";